import React from 'react';
import Head from 'next/head';
// eslint-disable-next-line import/no-unresolved
import CSS from 'csstype';

interface GoogleMapProps {
  // add Google Map props here
  mapsString: string;
  className?: string;
  style?: CSS.Properties;
  title?: string;
  zoomLevel?: number;
}

const GoogleMap: React.FC<GoogleMapProps> = ({
  mapsString,
  className,
  style,
  title,
  zoomLevel,
}: GoogleMapProps) => {
  const googleMapsBaseURL = 'https://maps.googleapis.com/maps/api/staticmap';

  const googleMapsKey = 'AIzaSyC-pgt2_8pcovSI6B98mVSHYbPsJGmES9c';

  const zoomQuery = `&zoom=${zoomLevel}`;

  return (
    <>
      <Head>
        <link
          rel='preconnect'
          href={googleMapsBaseURL}
          key='google-maps-preconnect'
        />
        <link
          rel='dns-prefetch'
          href={googleMapsBaseURL}
          key='google-maps-prefetch'
        />
      </Head>
      <div className={className} style={{ padding: 0 }}>
        <a
          href={`https://google.com/maps?q=${mapsString}${zoomQuery}`}
          target='_blank'
        >
          <img
            src={`${googleMapsBaseURL}?center=${mapsString}${zoomQuery}&size=600x300&markers=color:0xff58a5|${mapsString}&key=${googleMapsKey}`}
            alt={mapsString}
            style={{
              boxShadow: 'rgba(0, 0, 0, 0.15) 0px 3px 8px',
            }}
          />
        </a>
      </div>
    </>
  );
};

GoogleMap.defaultProps = {
  // add Google Map default props here
  className: null,
  style: null,
  title: null,
  zoomLevel: null,
};

export default GoogleMap;
